module.exports = __webpack_public_path__ + "img/scene_3.03356610.png";